module.exports = __webpack_public_path__ + "img/dental-office-tour-lobby2.5b1d9e18.png";